"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterableQuestions = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const getAllQuestions_1 = __importDefault(require("./getAllQuestions"));
const getFilterableQuestions = (parentNode) => {
    let array = (0, getAllQuestions_1.default)(parentNode);
    return array.filter(a => [
        FormQuestionType_1.default.ASSET,
        FormQuestionType_1.default.CHECK,
        FormQuestionType_1.default.DATETIME,
        FormQuestionType_1.default.LIST,
        FormQuestionType_1.default.NUMBER,
        FormQuestionType_1.default.RATING,
        FormQuestionType_1.default.SPT,
    ].includes(a.type));
};
exports.getFilterableQuestions = getFilterableQuestions;
exports.default = exports.getFilterableQuestions;
